export const WIFD = {
  id: 17,
  height: 6108695,
  data: {
    icon: "/imgs/icons/asset/wifd.webp",
  },
};
